var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcAttendanceStatusOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-attendanceStatus-on_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#458C94",
  d: "m27.243 12.992-9.04-4.742a2.13 2.13 0 0 0-2 0l-9.04 4.742a2.14 2.14 0 0 0-1.16 2 2.16 2.16 0 0 0 1.32 1.903l9.04 3.79c.26.112.556.161.84.161s.568-.049.84-.172l9.04-3.792a2.15 2.15 0 0 0 1.32-1.902 2.12 2.12 0 0 0-1.16-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B4DCE0",
  d: "M17.203 22.55a4 4 0 0 1-1.556-.308l-6.78-2.84v2.803c0 1.21.642 2.334 1.692 2.939 1.42.815 3.73 1.79 6.644 1.79 1.334 0 3.977-.234 6.681-1.803a3.38 3.38 0 0 0 1.655-2.914v-2.803l-6.78 2.84a3.9 3.9 0 0 1-1.556.309z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-attendanceStatus-on_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})))));
export default SvgIcAttendanceStatusOn;